// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2383":"81192981","4213":"81192981","4303":"81192981","7617":"9827450b"}[chunkId] + ".chunk.css";
};